import { ActionTypes } from '../actions'
const {
  FETCH_INITIAL_DATA_REQUEST,
  FETCH_INITIAL_DATA_RECEIVED,
  FETCH_ALL_DATA_RECEIVED,
  FETCH_MORE_DATA_RECEIVED,
  FETCH_MORE_DATA_REQUEST,
  FETCH_FILTERED_DATA_REQUEST,
  FETCH_FILTERED_DATA_RECEIVED,
  ADD_TO_CART_RESPONSE,
  ENABLE_FILTERS,
  CANCEL_LOADING
} = ActionTypes

const initialMisc = {
}
const misc = (state = initialMisc, action) => {
  switch (action.type) {
    case FETCH_INITIAL_DATA_REQUEST:
      return {
        ...state,
        dataIsLoading: true,
        filteredDataIsLoading: false,
        allDataIsLoading: true,
      }
    case FETCH_INITIAL_DATA_RECEIVED:
      return {
        ...state,
        ...action.data.misc,
        dataIsLoading: false,
      }
    case FETCH_ALL_DATA_RECEIVED:
      return {
        ...state,
        ...action.data.misc,
        allDataIsLoading: false,
      }
    case FETCH_MORE_DATA_REQUEST:
      return {
        ...state,
        page: state.page + 1,
        dataIsLoading: true,
      }
    case FETCH_MORE_DATA_RECEIVED:
      return {
        ...state,
        ...action.data.misc,
        leaguesOrder: [...state.leaguesOrder, ...action.data.misc.leaguesOrder],
        dataIsLoading: false,
      }
    case FETCH_FILTERED_DATA_RECEIVED:
      return {
        ...state,
        ...action.data.misc,
        leaguesOrder: action.data.misc.leaguesOrder,
        filteredDataIsLoading: false,
      }
    case FETCH_FILTERED_DATA_REQUEST:
      return {
        ...state,
        filteredDataIsLoading: true,
      }
    case ADD_TO_CART_RESPONSE:
      return {
        ...state,
        cartMerchantAccountId: action.data.merchant_account_id,
        cartMerchantAccountType: action.data.merchant_account_type,
      }
    case ENABLE_FILTERS:
      return {
        ...state,
        initialFiltersLoaded: true,
        filteredDataIsLoading: false,
      }
    case CANCEL_LOADING:
      return {
        ...state,
        dataIsLoading: false,
      }
    default:
      return state
  }
}
export default misc